import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import { AgentDockProvider } from "./context/AgentDockContext";
import AppShell from "./components/agent/AppShell";

const App = () => {
  return (
    <Router>
      <AgentDockProvider>
        <AppShell />
      </AgentDockProvider>
    </Router>
  );
};

export default App;
